export const formatHide = (str, showCount) => {
  if (str?.length > showCount * 2) {
    return str.slice(0, showCount) + '****' + str.slice(str.length - showCount);
  }
  return str;
};
